import * as BABYLON from 'babylonjs'
import { inspectorClic } from '@/core/utils.js'
import { getSlug } from '@/core/utils.js'

export default class HObject {
  constructor(name, type, allowRegistration = false) {
    this.name = name
    this.type = type
    this.allowRegistration = allowRegistration // Esta bandera es para que solo se procese lo inidicado en true desde el primer registro
    this.allowRegistrationDefault = allowRegistration // Se usa para restaurar el valor inicial de allowRegistration en unRegisterHObject de hScene
    this.hAppName = null
    this.meshRootName = null
    this.registered = false // Esta bandera es para que no se vuelvan a procesar los que estén en true, es decir los que ya han sido registrados
    this.visible = true

    this.groups = [] // Sin un uso actual, se usa para agrupación de mesh tags de BABYLON: https://doc.babylonjs.com/resources/tags
    this.tags = []
    this.options = [] // Arreglo de opciones para cuando se registre el hObject se ejecuten determinadas sinstrucciones según dichas opciones

    this.instructions = []

    this.position = {}
    this.rotation = {}

    this.position.x = 0
    this.position.z = 0
    this.position.y = 0

    this.rotation.x = 0
    this.rotation.z = 0
    this.rotation.y = 0

    this.widgets = []
  }

  init (hObject) {
    this.allowRegistrationDefault = hObject.allowRegistrationDefault
    this.hAppName = hObject.hAppName

    this.registered = hObject.registered
    this.visible = hObject.visible

    this.groups = hObject.groups
    this.tags = hObject.tags
    this.options = hObject.options

    this.instructions = hObject.instructions

    this.position = hObject.position
    this.rotation = hObject.rotation

    this.widgets = hObject.widgets
  }

  getMeshRootName () {
    if (!this.meshRootName) {
      this.meshRootName = this.hAppName + '.' + this.name + '.root'
    }
    return this.meshRootName
  }

  getMeshRoot () {
    if(!window.scene.getMeshByName(this.getMeshRootName())) {
      console.log('*******No se obtuvo mesh root: ')
      console.log(this.getMeshRootName())
    }
    return window.scene.getMeshByName(this.getMeshRootName())
  }

  getMeshByName (name) {
    let meshName = this.hAppName + '.' + this.name + '.' + name
    return window.scene.getMeshByName(meshName)
  }

  updateMeshesPositionRotation () {
    let hApp = window.hScene.hApps[this.hAppName]

    if (this.getMeshRoot()) {
      this.getMeshRoot().position.x = Number(hApp.content.position.x) + Number(this.position.x)
      this.getMeshRoot().position.z = Number(hApp.content.position.z) + Number(this.position.z)
      this.getMeshRoot().position.y = Number(hApp.content.position.y) + Number(this.position.y)
      this.getMeshRoot().rotation.x = Math.PI * this.rotation.x / 180
      this.getMeshRoot().rotation.z = Math.PI * this.rotation.z / 180
      this.getMeshRoot().rotation.y = Math.PI * this.rotation.y / 180
    }
  }

  /**
   * Configuraciones requeridas a los mesh posterior a la importación
   * @param {*} newMeshes // Arreglo de los mesh importados (clones e instancias)
   */
  objectConfigurations (newMeshes) {
    let i, j
    let hApp = window.hScene.hApps[this.hAppName]

    newMeshes = inspectorClic(newMeshes)

    // Renombrando meshes según jerarquía hApp.hObject.mesh
    for (i = 0; i < newMeshes.length; i++) {
      //Se renombra el mesh agregando como prefijos el nombre del hApp y el nombre del  hObject
      newMeshes[i].name = hApp.name + '.' + this.name + '.' + newMeshes[i].name
      //Husmind obtiene los meshes de un hObject mediante la búsqueda en babylon por tags:
      BABYLON.Tags.AddTagsTo(newMeshes[i], hApp.name + '.' + this.name)

      // Deprecated: el arreglo newMeshes recibirá mixto entre clones e instancias
      // y se les asignará directamente, mas no como la siguiente forma que es
      // iterar las instancias del actual mesh.  La siguiente iteración se deja
      // solamente para lograr mayor tolerancia por objetos de versiones anteriores
      if (typeof newMeshes[i].instances !== 'undefined') {
        for (j = 0; j < newMeshes[i].instances.length; j++) {
          newMeshes[i].instances[j].name = hApp.name + '.' + this.name + '.' + newMeshes[i].instances[j].name
          BABYLON.Tags.AddTagsTo(newMeshes[i].instances[j], hApp.name + '.' + this.name)
        }
      }
    }

    // Ubicación del mesh padre
    var meshRoot = this.getMeshRoot()
    // if (meshRoot === null){
    //   console.log('ALERTA NO SE DETECTO MESHROOT')
    // }
    if (this.getMeshRoot() === null) { // Si no tiene mesh padre usa el elemento 0 como mesh padre
      newMeshes[0].name = hApp.name + '.' + this.name + '.root'
      meshRoot = newMeshes[0]
    }

    // this.meshRootName = meshRoot.name

    // Emparentando clones e instancias que no tienen padre al declarado root
    for (i = 0; i < newMeshes.length; i++) {
      // Si no es root y no tiene padre:
      if (newMeshes[i].parent === undefined && newMeshes[i].name !== this.getMeshRootName()) {
        newMeshes[i].parent = this.getMeshRoot()
        // Revisar esta parte: No está funcionando bien con clones, solo con instancias
      }

      // Deprecated: el arreglo newMeshes recibirá mixto entre clones e instancias
      // y se les asignará directamente, mas no como la siguiente forma que es
      // iterar las instancias del actual mesh.  La siguiente iteración se deja
      // solamente para lograr mayor tolerancia por objetos de versiones anteriores
      if (typeof newMeshes[i].instances !== 'undefined') {
        for (j = 0; j < newMeshes[i].instances.length; j++) {
          newMeshes[i].instances[j].parent = meshRoot
        }
      }
    }

    // Activando colisiones
    for (i = 0; i < newMeshes.length; i++) {
      newMeshes[i].checkCollisions = true

      // Deprecated: el arreglo newMeshes recibirá mixto entre clones e instancias
      // y se les asignará directamente, mas no como la siguiente forma que es
      // iterar las instancias del actual mesh.  La siguiente iteración se deja
      // solamente para lograr mayor tolerancia por objetos de versiones anteriores
      if (typeof newMeshes[i].instances !== 'undefined') {
        for (j = 0; j < newMeshes[i].instances.length; j++) {
          newMeshes[i].instances[j].checkCollisions = true
        }
      }
    }

    // Ajuste de la posición de meshRoot a partir de la posición del hObjeto y del hApp
    this.updateMeshesPositionRotation()

    // Hacer codigo para dispose según arreglo en object
    // newMeshes[8].dispose()

    // Aplicando la visibilidad a los meshes según la visibilidad del hObject
    // for (i = 0; i < newMeshes.length; i++) {
    //   newMeshes[i].visibility = hObject.visible
    //   for (j = 0; j < newMeshes[i].instances.length; j++) {
    //     newMeshes[i].instances[j].visibility = hObject.visible
    //   }
    // }
  }

  /**
   * LOD - Level of Detail (¡Importante! No aplica para instancias)
   * @param {*} newMeshes
   * @param {*} distance
   */
  lod (newMeshes, distance = 200) {
    for (let i = 0; i < newMeshes.length; i++) {
      newMeshes[i].addLODLevel(distance, null)
    }
  }

  addWidget(widget) {
    let index = this.widgets.findIndex(element => element.meshName === widget.meshName)
    if (index >= 0) { // widget existente y sobreescribe o agrega lo que se requiera
      this.widgets[index] = {
        currentImage: 1,
        ...this.widgets[index], // Deja todos los atributos que tiene this.widgets[index]
        ...widget // Sobreescrbe los atributos por los que tenga el parámetro widget
      }
    } else { // widget nuevo
      widget.name = `${this.hAppName}.${this.name}.${widget.meshName}`
      widget.zoom = false
      widget.html = ''
      widget.title = ''
      widget.url = ''
      widget.numImages = 0
      widget.currentImage = 1

      this.widgets.push(widget)
    }
  }

  getIndexWidgetByName (name) {
    return this.widgets !== undefined ? this.widgets.findIndex(widget => widget.name === name) : -1
  }

  getIndexWidgetByMeshName (meshName) {
    return this.widgets !== undefined ? this.widgets.findIndex(widget => widget.meshName === meshName) : -1
  }

  getWidgetByName (name) {
    return this.widgets !== undefined ? this.widgets.find(widget => widget.name === name) : undefined
  }

  getWidgetByMeshName (meshName) {
    return this.widgets !== undefined ? this.widgets.find(widget => widget.meshName === meshName) : undefined
  }

  loadContentImages () {
    this.widgets.forEach(function (widget) {
      for (let i = 1; i <= widget.numImages; i++) {
        let imageName = getSlug(`${widget.name}-${i}`)
        if(window.scene.getMaterialByName(imageName) === null){ // Importante NO RETIRAR condicional
          let material = new BABYLON.StandardMaterial(imageName, window.scene)
          material.emissiveTexture = new BABYLON.Texture(`${ENV.server_back}/api/content/image/${imageName}`, window.scene)
        }
      }
    })
  }

  setContentFirstImages () {
    let hObject = this
    this.widgets.forEach(function (widget) {

      if (widget.numImages) {
        let imageName = getSlug(`${widget.name}-1`)
        hObject.getMeshByName(widget.meshName).material = window.scene.getMaterialByName(imageName)
      }

    })
  }
}



// WEBPACK FOOTER //
// ./src/core/HObject.js